import React, { useCallback } from 'react';
import { useJobsConfig } from './hooks/useJobsConfig';
import type { GetServiceImagesResponse } from '../types/service-images';
import ImageCarousel from '../PortalListing/components/ImageCarousel';

function Inner() {
  const config = useJobsConfig();
  const hasImages = config.jobImageCount + config.weighingImageCount > 0;

  const loadImage = useCallback(async (): Promise<string[] | null> => {
    const res = await fetch(config.imagesApi);

    if (!res.ok) {
      console.error('Failed to fetch images', await res.text());
      return null;
    }

    const data = (await res.json()) as GetServiceImagesResponse;

    return [...(data.jobImageUrls ?? []), ...(data.weighingImageUrls ?? []), ...(data.routeVisitImageUrls ?? [])];
  }, [config.imagesApi]);

  if (!hasImages) {
    console.warn('No images available for this job.');
    return null;
  }

  return (
    <div className="psd-card__status-box-carousel">
      <ImageCarousel imageLoader={loadImage} customClass="psd-card__status-box-image" isSmall={true} />
    </div>
  );
}

export default function App() {
  return <Inner />;
}
